import React from 'react'
import WhatsAppLogo from '../../assets/images/whatsapp_logo.svg';

const LoginRightBottom = () => {
    return (
        <>
               {/* <div className="query">
                    <p>For any queries, please reach out to <a href="mailto:info@ciisummit.com">info@ciisummit.com</a> or WhatsApp <a href="tel:+919109910733">+91 9109910733</a></p>
                </div> */}

                <div className="or-row"><span>Or</span></div>

                <div className="login-other-link">
                    <a target="_blank" rel="noreferrer" href="https://ciisummit.com/registrations/">Register Now</a>
                    <a target="_blank" rel="noreferrer" href="https://ciisummit.com/faq/">FAQ</a>
                </div>

                <div className="mobile-query">
                    <p>For any queries, please reach out to us:</p> 
                
                    <div className="app-link-box">
                        <a href="mailto:info@ciisummit.com"><span _ngcontent-nkx-c37="" className="material-icons-outlined">email</span></a>
                        <a target="_blank" rel="noreferrer" href="https://wa.me/+919109910733"><img src={WhatsAppLogo} alt="WhatsApp Logo" /></a>
                    </div>
                </div>
        </>
    )
}


export default LoginRightBottom;